var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9938 14.4451L31.2192 21.5972C31.4241 27.7712 29.3815 30.8377 24.2293 31.7005C23.4071 31.8518 22.499 31.9399 21.5048 31.9647L18.6277 32.0454C11.4875 32.2505 8.5221 29.4906 8.29668 22.3385L8.06694 15.1704C8.02225 13.7158 8.08941 12.4209 8.30924 11.3095C9.14889 6.90889 12.0722 5.00405 17.7899 4.8351L20.6467 4.74257C27.8148 4.51283 30.7683 7.29312 30.9938 14.4451Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.229 31.6998C23.4068 31.8511 22.4986 31.9392 21.5045 31.964L18.6274 32.0447C11.4871 32.2497 8.52179 29.4898 8.29636 22.3378L8.06662 15.1697C8.02193 13.715 8.0891 12.4202 8.30893 11.3088M15.6485 15.2605L23.9869 15.1485M15.7402 21.9134L20.728 21.8538",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProject);
export default __webpack_public_path__ + "static/media/MyProject.2816a13b468cc0c0c09b68d8f8631bca.svg";
export { ForwardRef as ReactComponent };